@if (formPageNotConfigured) {
  <scitis-empty-state-fallback [fallBackMessage]="fallBackMessage">
  </scitis-empty-state-fallback>
}

@if (!formPageNotConfigured) {
  <div class="page-content form-page card">
    <div class="card-body d-flex flex-column justify-content-center">
      <div class="row justify-content-center form-page-content">
        <form class="col-12 col-md-10 col-lg-8 col-xl-6">
          @for (inputField of formPageConfiguration.inputFields; track inputField) {
            <scitis-form-page-field (inputFieldChange)="onInputFieldChanged()"
              [inputField]="inputField"
              [clearFormTrigger]="clearFormTrigger">
            </scitis-form-page-field>
          }
          <div class="form-row">
            <div class="col">
              <button (click)="onSubmit()" [disabled]="shouldDisableSubmitButton" class="btn btn-primary btn-block"
                type="button">
                <span translate>Submit</span>
              </button>
            </div>
            <div class="col-auto">
              <button (click)="onClearForm()" class="btn btn-outline-primary btn-block" type="button">
                <span translate>Clear form</span>
              </button>
            </div>
            <div class="col-auto">
              <button (click)="onShowLastSubmittedRow()" class="btn btn-outline-primary btn-block" type="button">
                <span translate>Show last submitted row</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
}
